import { useEffect, useState } from 'react';
import { Api } from '../../../services/api';
import { CanvaEditUser } from './CanvaEditUser';
import { DeleteUser } from './DeleteUser';
import { LoadingCubeComponent } from '../../../Components/LoadingCubeComponent';

export const TableListUser = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState(null);

  const findUsers = async () => {
    setIsLoading(true);
    try {
      const resp = await Api.get('/user');

      setUsers(resp.data);
    } catch {
      setUsers(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    findUsers();
  }, []);

  return (
    <>
      <div style={{ width: '100%', textAlign: 'right' }}>
        <button className="btn btn-outline-secondary" onClick={findUsers}>
          Atualizar Lista
        </button>
      </div>
      <div style={{ maxHeight: '60vh', overflowX: 'hidden', overflowY: 'auto' }}>
        <table className="table table-striped table align-middle" style={{ width: '100%' }}>
          <thead>
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">Usuário</th>
              <th scope="col">Acesso</th>
              <th scope="col">-</th>
              <th scope="col">-</th>
            </tr>
          </thead>
          <tbody className="table-group-divider">
            {users &&
              users.map((user) => (
                <tr key={user.id}>
                  <td>{user.nome}</td>
                  <td>{user.nick}</td>
                  <td>Admin</td>
                  <td>
                    <CanvaEditUser user={user} updateList={findUsers} />
                  </td>
                  <td>
                    <DeleteUser user={user} updateList={findUsers} />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {isLoading && <LoadingCubeComponent />}
    </>
  );
};
